module.exports = __webpack_public_path__ + "static/media/image_icon.8f6da5f8.svg";